import React from 'react';
import type CycleTimeReportType from '@jira/spa-apps__cycle-time-report/src/CycleTimeReportSpa.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

/** @deprecated remove when clean up entrypoint_migration_reports_cycle_time_classic */
export const LazyCycleTimeReport: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof CycleTimeReportType
>(
	() =>
		import(
			/* webpackChunkName: "async-cycle-time-report", jiraSpaEntry: "async-cycle-time-report" */ '@jira/spa-apps__cycle-time-report/src/CycleTimeReportSpa.tsx'
		),
);

export const CycleTimeReportNextGen = (): React.JSX.Element => (
	<LazyPage Page={LazyCycleTimeReport} pageId="cycleTimeReportNextGen" shouldShowSpinner />
);

export const CycleTimeReportClassic = (): React.JSX.Element => (
	<LazyPage Page={LazyCycleTimeReport} pageId="cycleTimeReportClassic" shouldShowSpinner />
);
